import { FC, useState, useEffect, useMemo } from 'react'
import styled from 'styled-components'
import { Table, Button, Space, Input } from 'antd'
import { useNavigate } from 'react-router-dom'

import PageLayout from '../../components/page-layout/page-layout'
import HelpDrawerList from './components/help-drawer/help-drawer-list'
import TableWrapper from '../../components/table-wrapper/table-wrapper'

import { routes } from '../../constants/routes'
import { clientsColumns } from './constants/columns'
import { useScopedContractorsQuery } from '../../hooks/api/use-scoped-contractors-query'

import useEndpointQueryParams, {
    DeserializeFilters,
} from '../../hooks/table-pages/use-endpoint-query-parameters'
import useTablePagination from '../../hooks/table-pages/use-table-pagination'
import { EndpointQueryParameters } from '../../types/strapi/strapi'

const ClientsPageStyled = styled.div`
    height: 100vh;
    display: flex;
    flex-direction: column;
`

const deserializeFilters: DeserializeFilters = filtersString => {
    return {}
}

const ClientsPage: FC = () => {
    const navigate = useNavigate()
    const params = useEndpointQueryParams({ deserializeFilters })
    const [search, setSearch] = useState('')

    const filters = useMemo(
        () => ({
            type: { name: { $contains: 'Клиент' } },
            ...params.filters,
            ...(search ? { name: { $containsi: search } } : {}),
        }),
        [search, params.filters]
    )

    const contractorsQueryParams: EndpointQueryParameters = {
        populate: { type: true, curators: { populate: { user: true } }, contractor_contacts: true },
        filters,
        pagination: params.pagination,
        sort: ['createdAt:desc'],
    }

    const { data, isLoading } = useScopedContractorsQuery(contractorsQueryParams, {
        pollingInterval: 180000,
        skipPollingIfUnfocused: true,
    })
    const pagination = useTablePagination(params, data)

    useEffect(() => {
        const pageSize = params.pagination?.pageSize || 40
        pagination.onChange?.(1, pageSize)
    }, [search, params.pagination?.pageSize])

    return (
        <PageLayout title='Клиенты' beforeUser={<HelpDrawerList />}>
            <ClientsPageStyled>
                <Space style={{ marginBottom: 16 }}>
                    <Input.Search
                        placeholder='Поиск по имени'
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        style={{ width: 300 }}
                        allowClear
                    />
                    <Button type='primary' onClick={() => navigate(routes.clientsAdd)}>
                        Добавить клиента
                    </Button>
                </Space>

                <TableWrapper>
                    <Table
                        rowKey='documentId'
                        loading={isLoading}
                        columns={clientsColumns}
                        dataSource={data?.data || []}
                        pagination={pagination}
                    />
                </TableWrapper>
            </ClientsPageStyled>
        </PageLayout>
    )
}

export default ClientsPage
